export const BIRTH_CONTROL_URL_BASE = "birth-control";
export const EMERGENCY_CONTRACEPTION_URL_BASE = "emergency-contraception";
